import { Component } from '@angular/core';

interface SolutionCard {
  icon: string;
  title: string;
  description: string;
}

@Component({
  selector: 'app-solutions-overview-redesign',
  templateUrl: './solutions-overview-redesign.component.html',
  styleUrls: ['./solutions-overview-redesign.component.scss']
})
export class SolutionsOverviewRedesignComponent {

  introText = `Althea Soft provides clinical AI solutions for healthcare institutions that need to make mental healthcare more predictive, connected and efficient.
  Our platform helps hospitals, clinics, public health systems and mental health organisations detect risks earlier, monitor patients in real time and coordinate care teams across the patient journey.`;

  solutions: SolutionCard[] = [
    {
      icon: 'assets/img/redesign/solutions/icon-remote-monitoring.png',
      title: 'Remote Patient Monitoring',
      description: 'Extend clinical visibility beyond the hospital. Althea Soft integrates real-time monitoring, biometric data and wearable devices to help care teams follow patient evolution remotely while maintaining clinical oversight.'
    },
    {
      icon: 'assets/img/redesign/solutions/icon-clinical-coordination.png',
      title: 'Clinical Coordination',
      description: 'Connect multidisciplinary teams around shared patient intelligence. The platform helps psychologists, psychiatrists, physicians, nurses and other authorised professionals work from the same information, improving communication, traceability and decision-making.'
    },
    {
      icon: 'assets/img/redesign/solutions/icon-ai.svg',
      title: 'Hands-Free AI Assistance',
      description: 'Voice-Activated Workflows, Instant Dictation Engine, Intelligent Diagnostic Predictions and Automated Risk Assessments. Real-time clinical notes into structured records instantly during patient sessions, Switch seamlessly between complex patient metrics, charts, and image views using only vocal cues.'
    },
    {
      icon: 'assets/img/redesign/solutions/icon-mental-health.png',
      title: 'Mental Health Institutions',
      description: 'Improve the management of patients with severe or complex mental health conditions. Our platform helps specialised institutions strengthen continuity of care, coordinate psychiatric, psychological and medical teams, and identify changes in patient status before they become critical.'
    },
    {
      icon: 'assets/img/redesign/solutions/icon-hospitals.png',
      title: 'Hospitals & Clinics',
      description: 'Support clinical teams with real-time patient insights, predictive alerts and better coordination between departments. Althea Soft helps hospitals and clinics optimise resources, improve patient follow-up and reduce avoidable escalations that can lead to unnecessary admissions or longer stays.'
    },
    {
      icon: 'assets/img/redesign/solutions/icon-government.png',
      title: 'Governments & Public Health',
      description: 'Enable scalable mental health monitoring and prevention across populations. Althea Soft supports public health systems with tools for early risk detection, vulnerable population monitoring and more efficient use of healthcare resources.'
    }
  ];

  trackByTitle(index: number, item: SolutionCard): string {
    return item.title;
  }

}